<template>
  <div>
    <v-row dense>
      <v-col cols='12'>
        <v-text-field
          label='Address'
          :rules='[rules.required]'
          v-model='value.site_address'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='12'>
        <v-text-field
          label='City'
          :rules='[rules.required]'
          v-model='value.site_city'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='5'>
        <v-text-field
          label='Province'
          v-model='value.site_province'
        ></v-text-field>
      </v-col>
      <!--
      <v-col cols='12' md='8'>
        <v-text-field
          label='Country'
          v-model='value.site_country'
        ></v-text-field>
      </v-col>
      -->
      <v-col cols='12' md='5'>
        <!-- <v-text-field
          label='Postal Code'
          v-model='value.site_postal_code'
        ></v-text-field> -->
        <wc-postal-code-input
          v-model='value.site_postal_code'
        ></wc-postal-code-input>
      </v-col>
      <v-col cols='10' md='5'>
        <v-text-field
          label='Latitude'
          v-model='value.lat'
          maxlength='20'
          counter
        ></v-text-field>
      </v-col>
      <v-col cols='10' md='5'>
        <v-text-field
          label='Longitude'
          v-model='value.lng'
          maxlength='20'
          counter
        ></v-text-field>
      </v-col>
      <v-col cols='2' md='2'>
        <v-tooltip open-delay='500' top>
          <template v-slot:activator='{ on }'>
            <div v-on='on' class='d-inline-block'>
              <v-btn icon large class='ml-4 mt-3' :disabled='disableMapping' @click='getCoordinates'>
                <v-icon large color='grey darken-1'>mdi-map-marker-left</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Set the Geolocation for this address</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
    
    <v-col cols='12'>
      <v-card-text class='caption mb-n6'>The <v-icon x-small color='grey darken-1'>mdi-map-marker-left</v-icon> button above will set the geolocation based on Google's knowledge of that address.</v-card-text>
      <v-card-text class='caption' v-if='!$vuetify.breakpoint.smAndDown'>The <v-icon x-small color='grey darken-1'>mdi-map-marker</v-icon> button below will open a new window and drop a pin based on Google's location for the address (not the geolocation - if you've set that manually)</v-card-text>

      <v-card-text class='caption'>The actual route group/number is best set on the project routing page once the estimate is sold (though setting the route group here will automatically sort it into that group when if/when it becomes a project.)</v-card-text>
    </v-col>
      
      <v-col cols='10' md='5'>
        <v-text-field
          label='Route Group'
          v-model='value.route_group'
          :rules='[geoRules.uppercase]'
          :hint='isLawnEstimate ? "cannot be set here" : "(optional - if known)"'
          persistent-hint
          maxlength='2'
          counter
          :disabled='isLawnEstimate'
        ></v-text-field>
      </v-col>
      <v-col cols='10' md='5'>
        <v-text-field
          label='Route Number'
          v-model='value.route_number'
          :rules='[rules.intOrEmpty]'
          maxlength='3'
          counter
          hint="(optional)"
          persistent-hint
          :disabled='!value.route_group'
        ></v-text-field>
      </v-col>
      <v-col cols='2' md='2' v-if='!$vuetify.breakpoint.smAndDown'>
        <v-tooltip open-delay='500' top>
          <template v-slot:activator='{ on }'>
            <div v-on='on' class='d-inline-block'>
              <v-btn icon large class='ml-2 mt-3' :disabled='disableMapping' @click='mapAddress'>
                <v-icon large color='grey darken-1'>mdi-map-marker</v-icon>
              </v-btn>
            </div>
          </template>
          <span>{{mappingTooltip}}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import _ from 'lodash'
import gmapsInit from '@/utils/gmaps'
import formRules from '@/mixins/formRules'
import WCPostalCodeInput from '@/components/forms/WCPostalCodeInput'

export default {
  name: 'site-address-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    }
  },
   data: () => ({
    isLoading: false,
    google: null,
    geocoder: null
  }),
  mounted() {
    this.initMap()
  },
  computed: {
    geoRules() {
      return {
        uppercase: (value) => {
          const pattern = /^[A-Z]{1,2}$|^null$|^(?![\s\S])/
          return pattern.test(value) || 'Uppercase (or empty)'
        },
      }
    },
    disableMapping() {
      if (!this.value.site_address || !this.value.site_city) {
        return true
      }
      return false
    },
    mappingTooltip() {
      if (!this.value.site_address || !this.value.site_city) {
        return 'Address and City are required for mapping'
      }
      return 'Map this address (opens in new window)'
    },
    isLawnEstimate () {
      return this.value.division_obj.division === "Lawn"
    }
  },
  methods : {
    async mapAddress () {
      let URL = "https://www.google.com/maps/place/" + this.value.site_address + '+' + this.value.site_city
      window.open(URL, '_blank', )
    },
    async initMap() {
      try {
        this.google = await gmapsInit()
      } catch (error) {
        console.error(error);
      }
    },
    getCoordinates() {
      this.geocoder = new this.google.maps.Geocoder();
      let address = this.value.site_address + ", " + this.value.site_city
      this.geocoder.geocode( { 'address': address}, (results, status) => {
        if (status == 'OK') {
          console.log('got results')
          console.log(results)
          this.value.lat = results[0].geometry.location.lat()
          this.value.lng = results[0].geometry.location.lng()
        } else {
          alert('Geocode was not successful for the following reason: ' + status)
        }
      })
    }
  },
  components: {
    'wc-postal-code-input': WCPostalCodeInput
  }
}
</script>
